import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";

function AlmostDoneModal({ show, close, switchToEnglish, text }) {
  return (
    <Modal isOpen={show} toggle={close} modalClassName="help-dialog" size="lg">
      <div className="semicircle-button-container">
        <div className="semicircle-button done" onClick={close}>
          {"×"}
        </div>
      </div>
      <ModalBody>
        <div className="text primary">{text.englishRequired}</div>

        <div className="row">
          <div className="col-12">
            <div className="wizard-text">&nbsp;</div>
            <div className="form-group">
              <div className="col-12 modal-footer-container">
                <Button
                  color="primary"
                  size="lg"
                  block={true}
                  onClick={switchToEnglish}
                >
                  {text.signEnglishForm}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

AlmostDoneModal.propTypes = {
  close: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  switchToEnglish: PropTypes.func.isRequired,
  text: PropTypes.object.isRequired,
};

export default AlmostDoneModal;



// WEBPACK FOOTER //
// ./src/components/EnglishWarningModal.js